const env: string = process.env.REACT_APP_ENVIRONMENT || 'prod';
const cacaoPrivacyPolicyUrl = 'https://www.cacaopaycard.com/avisoprivacidad/';
const cacaoEmail = 'une@cacaopaycard.com';

export { env, cacaoPrivacyPolicyUrl, cacaoEmail };
